import { render, staticRenderFns } from "./lightBlue.vue?vue&type=template&id=2c0b2b6f&scoped=true"
import script from "./lightBlue.vue?vue&type=script&lang=js"
export * from "./lightBlue.vue?vue&type=script&lang=js"
import style0 from "./lightBlue.vue?vue&type=style&index=0&id=2c0b2b6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b2b6f",
  null
  
)

export default component.exports